import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

export default {
  postApi: (bvModal, params, callbackSuccess, callbackFinally) => {
    return AppModel.post(
      'mawashi/sheets',
      bvModal,
      params,
      callbackSuccess,
      callbackFinally
    )
  },
  getStore: (key) => {
    return AppModel.getStore('mawashi_sheets', key)
  },
  removeStore: () => {
    delete store.getters.model.agenda
  }
}



// WEBPACK FOOTER //
// ./src/models/MawashiSheetsModel.js